module.exports = __webpack_public_path__ + "media/img/Landing_Page/email-icon-e82c2cc613d3fb8c145c894aa927544a.png";